const conwayMonthCodes = {
  A: 'Jan',
  B: 'Feb',
  C: 'Mar',
  D: 'Apr',
  E: 'May',
  F: 'Jun',
  G: 'Jul',
  H: 'Aug',
  J: 'Sep',
  K: 'Oct',
  L: 'Nov',
  M: 'Dec',
};

const conwayYearCodes = {
  J: 2015,
  K: 2016,
  L: 2017,
  M: 2018,
  N: 2019,
  P: 2020,
  Q: 2021,
  R: 2022,
  S: 2023,
  T: 2024,
  U: 2025,
  V: 2026,
  W: 2027,
  X: 2028,
  Y: 2029,
  Z: 2030,
  A: 2031,
};

const conwayPrefixes = {
  DA0: {
    model: 'unknown',
    marketingName: 'V3300',
    brand: 'John Bean',
    family: 'V3300',
    host: 'wireless',
  },
  H16: {
    model: 'EEWA721G',
    marketingName: 'Geoliner 630',
    brand: 'Hofmann',
    family: 'V2000',
    host: 'wired',
  },
  H25: {
    model: 'EEWA752B2',
    marketingName: 'Geoliner 770',
    brand: 'Hofmann',
    family: 'V3300',
    host: 'wired',
  },
  H26: {
    model: 'EEWA752H2',
    marketingName: 'Geoliner 770',
    brand: 'Hofmann',
    family: 'V3300',
    host: 'wired',
  },
  H27: {
    model: 'EEWA752BV2',
    marketingName: 'Geoliner 770',
    brand: 'Hofmann',
    family: 'V2000',
    host: 'wired',
  },
  H28: {
    model: 'EEWA752HV2',
    marketingName: 'Geoliner 770',
    brand: 'Hofmann',
    family: 'V2000',
    host: 'wired',
  },
  H29: {
    model: 'EEWA712T',
    marketingName: 'Geoliner 660',
    brand: 'Hofmann',
    family: 'V2000',
    host: 'wired',
  },
  H32: {
    model: 'EEWA751H',
    marketingName: 'Geoliner 320',
    brand: 'Hofmann',
    family: 'V1200',
    host: 'wireless',
  },
  H35: {
    model: 'EEWA752HV3',
    marketingName: 'Geoliner 608',
    brand: 'Hofmann',
    family: 'V2000',
    host: 'wireless',
  },
  H36: {
    model: 'EEWA752HV3',
    marketingName: 'Geoliner 770',
    brand: 'Hofmann',
    family: 'V3300',
    host: 'wired',
  },
  HC2: {
    model: 'EEWA712TH3',
    marketingName: 'Geoliner 660',
    brand: 'Hofmann',
    family: 'V2000',
    host: 'wired',
  },
  HG5: {
    model: 'EEWA752B',
    marketingName: 'Geoliner 770',
    brand: 'Hofmann',
    family: 'V3300',
    host: 'wireless',
  },
  HG6: {
    model: 'EEWA752H',
    marketingName: 'Geoliner 770',
    brand: 'Hofmann',
    family: 'V3300',
    host: 'wireless',
  },
  HG8: {
    model: 'EEWA752BV3',
    marketingName: 'Geoliner 770',
    brand: 'Hofmann',
    family: 'V3300',
    host: 'wired',
  },
  HG9: {
    model: 'EEWA715THV3',
    marketingName: 'Geoliner 678',
    brand: 'Hofmann',
    family: 'V2000',
    host: 'wired',
  },
  J12: {
    model: 'EEWA551H',
    marketingName: 'V1200',
    brand: 'John Bean',
    family: 'V1200',
    host: 'wireless',
  },
  V89: {
    model: 'EEWA552B',
    marketingName: 'V3300',
    brand: 'John Bean',
    family: 'V3300',
    host: 'wireless',
  },
  V92: {
    model: 'unknown',
    marketingName: 'V3300',
    brand: 'John Bean',
    family: 'V3300',
    host: 'wireless',
  },
  V93: {
    model: 'EEWA552H',
    marketingName: 'V3300',
    brand: 'John Bean',
    family: 'V3300',
    host: 'wireless',
  },
  V98: {
    model: 'EEWA552HV',
    marketingName: 'V3300',
    brand: 'John Bean',
    family: 'V3300',
    host: 'wireless',
  },
  VA2: {
    model: 'EEWA544TH3',
    marketingName: 'V2280',
    brand: 'John Bean',
    family: 'V2000',
    host: 'wired',
  },
  VA3: {
    model: 'EEWA54TB3',
    marketingName: 'V2280',
    brand: 'John Bean',
    family: 'V2000',
    host: 'wired',
  },
  VA4: {
    model: 'EEWA715TB3',
    marketingName: 'Geoliner 678',
    brand: 'Hofmann',
    family: 'V2000',
    host: 'wired',
  },
  VA5: {
    model: 'EEWA715TH3',
    marketingName: 'Geoliner 678',
    brand: 'Hofmann',
    family: 'V2000',
    host: 'wired',
  },
  VA6: {
    model: 'EEWA540TH3',
    marketingName: 'V2000',
    brand: 'John Bean',
    family: 'V2000',
    host: 'N/A',
  },
  VA7: {
    model: 'EEWA545TBV3',
    marketingName: 'V2380',
    brand: 'John Bean',
    family: 'V2000',
    host: 'wired',
  },
  VB2: {
    model: 'EEWA552B2',
    marketingName: 'V3300',
    brand: 'John Bean',
    family: 'V3300',
    host: 'wired',
  },
  VB3: {
    model: 'EEWA552BV2',
    marketingName: 'V3300',
    brand: 'John Bean',
    family: 'V3300',
    host: 'wired',
  },
  VB4: {
    model: 'EEWA522BEE2',
    marketingName: 'V3300',
    brand: 'John Bean',
    family: 'V3300',
    host: 'wired',
  },
  VB5: {
    model: 'EEWA545TH3',
    marketingName: 'V2380',
    brand: 'John Bean',
    family: 'V2000',
    host: 'wired',
  },
  VB6: {
    model: 'EEWA715TBV3',
    marketingName: 'Geoliner 678',
    brand: 'Hofmann',
    family: 'V2000',
    host: 'wired',
  },
  VB7: {
    model: 'EEWA545THV3',
    marketingName: 'V2380',
    brand: 'John Bean',
    family: 'V2000',
    host: 'wired',
  },
  VB9: {
    model: 'EEWA545TBEE3',
    marketingName: 'V2380',
    brand: 'John Bean',
    family: 'V2000',
    host: 'wired',
  },
  VH3: {
    model: 'EEWA552HV2',
    marketingName: 'V3300',
    brand: 'John Bean',
    family: 'V3300',
    host: 'wired',
  },
  VH4: {
    model: 'EEWA544T',
    marketingName: 'V2280',
    brand: 'John Bean',
    family: 'V2000',
    host: 'wired',
  },
  W12: {
    model: 'EEWA752BV',
    marketingName: 'Geoliner 770',
    brand: 'Hofmann',
    family: 'V3300',
    host: 'wireless',
  },
  W13: {
    model: 'EEWA752HV',
    marketingName: 'Geoliner 770',
    brand: 'Hofmann',
    family: 'V3300',
    host: 'wireless',
  },
  W16: {
    model: 'EEWA541G',
    marketingName: 'V2100',
    brand: 'John Bean',
    family: 'V2000',
    host: 'wired',
  },
  W18: {
    model: 'EEWA544R',
    marketingName: 'V2380',
    brand: 'John Bean',
    family: 'V2000',
    host: 'wired',
  },
  YAA: {
    model: 'EEWA544R',
    marketingName: 'Tru-Point',
    brand: 'John Bean',
    family: 'GTPS',
    host: 'wired',
  },
  YAB: {
    model: 'EEWA544R',
    marketingName: 'Tru-Point',
    brand: 'John Bean',
    family: 'GTPS',
    host: 'wired',
  },
  H43: {
    model: '?',
    marketingName: 'Geoliner 609',
    brand: 'Hofmann',
    family: 'V2000',
    host: 'N/A',
  },
};

const conwaySerialNumberPrefixes = [
  'DA0',
  'H16',
  'H25',
  'H26',
  'H27',
  'H28',
  'H29',
  'H32',
  'H35',
  'H36',
  'HC2',
  'HG5',
  'HG6',
  'HG8',
  'HG9',
  'J12',
  'V89',
  'V92',
  'V93',
  'V98',
  'VA2',
  'VA3',
  'VA4',
  'VA5',
  'VA6',
  'VA7',
  'VB2',
  'VB3',
  'VB4',
  'VB5',
  'VB6',
  'VB7',
  'VB9',
  'VH2',
  'VH3',
  'VH4',
  'W12',
  'W13',
  'W16',
  'W18',
  'YAA',
  'YAB',
  'H43',
];

function isConwaySerialNumber(serialNumber) {
  const prefix = serialNumber.slice(0, 3);

  return (
    (serialNumber.length === 8 || serialNumber.length === 9)
    && (conwaySerialNumberPrefixes.indexOf(prefix) >= 0)
  );
}

function decodeConwaySerialNumber(serialNumber) {
  const prefix = serialNumber.slice(0, 3);
  const monthCode = serialNumber.slice(3, 4);
  const yearCode = serialNumber.slice(4, 5);
  const sequenceNumber = serialNumber.slice(5);

  const modelInfo = conwayPrefixes[prefix];
  if (modelInfo) {
    return Object.assign({}, modelInfo, {
      buildMonth: conwayMonthCodes[monthCode],
      buildYear: conwayYearCodes[yearCode],
      sequenceNumber,
    });
  }

  return {
    model: 'unknown',
    marketingName: 'unkown',
    brand: 'unknown',
    family: 'unknown',
    host: 'unknown',
    buildMonth: conwayMonthCodes[monthCode],
    buildYear: conwayYearCodes[yearCode],
    sequenceNumber,
  };
}

function decodeSerialNumber(serialNumber) {
  let result = null;

  if (isConwaySerialNumber(serialNumber)) {
    result = decodeConwaySerialNumber(serialNumber);
  }

  return result;
}

module.exports = decodeSerialNumber;
